import type { ICategory, ITop8CategoryList } from '../types';

  
export const sortCategories = (allCategories: ICategory[], topCategories: ITop8CategoryList[] | undefined) => {
  const topCategoryIds = (topCategories ?? []).map((cat: { id: string; }) => cat.id);
  
  const sorted: ICategory[] = [];
  const unmatched: ICategory[] = [];
  
  allCategories.forEach((category: ICategory) => {
    if (topCategoryIds.includes(category.id)) {
      sorted.push(category);
    } else {
      unmatched.push(category);
    }
  });

  unmatched.forEach((category: ICategory) => { sorted.push(category); });
  return sorted;
};
